import { render, staticRenderFns } from "./TagsSelect.vue?vue&type=template&id=1f5abdcc&scoped=true&"
import script from "./TagsSelect.vue?vue&type=script&lang=js&"
export * from "./TagsSelect.vue?vue&type=script&lang=js&"
import style0 from "./TagsSelect.vue?vue&type=style&index=0&id=1f5abdcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5abdcc",
  null
  
)

export default component.exports